import logo_header_desktop from '../../../assets/imgs/logo_header_desktop_white.svg'
import { PAGE_URLS } from '../../../constants/hrefLinks'
import './style.scss'

function HeaderLogoWhite() {
	return (
		<div className='header-logo-wrap'>
			<a href={PAGE_URLS.SEARCH}>
				<img 
					src={logo_header_desktop}
					className="header-logo"
					alt="Skivio logo" 
				/>
			</a>
		</div>
	)
}

export default HeaderLogoWhite